export default __webpack_public_path__ + "static/media/ความสำคัญของกิจกรรม-1.ec28b088.png";